import { Tooltip_detail as Tooltip } from "../../utility/common/helpers/Tooltip";
import Img from "../../../icons/ErrorIcon.svg";
import {
  Process_Grid_Input_2
} from "../../utility/common/TransactionComponents/Common_WPS_WPQ_PQR_Process_Input_Fields";

//-----below in use

export const PQR_Process_Grid_InputProcess = ({
  detailObj,
  ColumnHeader,
  Columndimension,
  type,
  name,
  onInput,
  disabled,
  maxLength,
}) => {

  return (
    <tr className={"border WpsInput-md"}>
      <th
        className={"text-start thead-color"}
      >
        <div>
          <div className="headwidth">{ColumnHeader} </div>
          <span>{Columndimension}</span>
        </div>
      </th>
      <td
        className={"border WPSSelect"}
      // key={id}
      >
        <input
          style={{ width: "275px" }}
          type={type}
          name={name}
          value={"GTAW"}
          readOnly
          disabled={disabled}
          maxLength={maxLength}
        />
      </td>

    </tr>
  );
};



export const PQR_TTS_Process_Grid_Input = ({
  status,
  message,
  ColumnHeader,
  Columndimension,
  type,
  name,
  handleChangedetailsarray,
  onInput,
  detailObj,
  maxLength,
  width1
}) => {

  let textwidth = width1 != undefined ? width1 : "";
  return (
    <tr className={status ? "border WpsInput-md error" : "border WpsInput-md"}>
      <th
        className="text-start thead-color"
      >
        <div>
          <div className="headwidth">{ColumnHeader} </div>
          <span>{Columndimension}</span>
          {status && (
            <Tooltip content={message}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>

      <td className={status ? "border WPSSelect error" : "border WPSSelect"}>
        <input
          style={{ position: "relative", top: "4px", width: textwidth }}
          className={status ? "error-input" : ""}
          type={type}
          name={name}
          value={detailObj?.[name]}
          maxLength={maxLength}
          onChange={(e) => {
            handleChangedetailsarray(e);
          }}
          onInput={onInput}
        />
      </td>
    </tr>
  );
};

export const PQR_TTS_Process_Grid_Input_2 = ({
  status,
  message,
  ColumnHeader,
  Columndimension,
  type,
  name,
  handleChangedetailsarray,
  onInput,
  detailObj,
  maxLength,
  width1
}) => {
  let textwidth = width1 != undefined ? width1 : "";
  const values = Array.isArray(detailObj?.[name]) ? detailObj[name] : ["", ""];
  return (
    <tr className={status ? "border WpsInput-md error" : "border WpsInput-md"}>
      <th className="text-start thead-color">
        <div>
          <div className="headwidth">{ColumnHeader} </div>
          <span>{Columndimension}</span>
          {status && (
            <Tooltip content={message}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>
      <td className={status ? "border WPSSelect error" : "border WPSSelect"}>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <input
            style={{ width: textwidth }}
            className={status ? "error-input" : ""}
            type={type}
            name={name}
            value={values[0] || ""}
            maxLength={maxLength}
            onChange={(e) => {
              const newArr = [...values];
              newArr[0] = e.target.value;
              handleChangedetailsarray({ target: { name, value: newArr } });
            }}
            onInput={onInput}
          />
          <input
            style={{ width: textwidth }}
            className={status ? "error-input" : ""}
            type={type}
            name={name}
            value={values[1] || ""}
            maxLength={maxLength}
            onChange={(e) => {
              const newArr = [...values];
              newArr[1] = e.target.value;
              handleChangedetailsarray({ target: { name, value: newArr } });
            }}
            onInput={onInput}
          />
        </div>
      </td>
    </tr>
  );
};

export const PQRProcessGridInput2 = ({
  status,
  message,
  detailObj,
  ColumnHeader,
  Columndimension,
  type,
  name,
  readOnly,
  mainheading,
  onInput1,
  handleChangedetailsarray,
  maxLength,
  onInput,
  ColumnHeader1,
  name1,
  width1
}) => {
  return (
    <Process_Grid_Input_2
      status={status}
      message={message}
      detailObj={detailObj}
      ColumnHeader={ColumnHeader}
      Columndimension={Columndimension}
      type={type}
      name={name}
      readOnly={readOnly}
      mainheading={mainheading}
      handleChangedetailsarray={handleChangedetailsarray}
      maxLength={maxLength}
      ColumnHeader1={ColumnHeader1}
      name1={name1}
      width={width1}
      onInput={onInput}
      onInput1={onInput1}
    />
  );
};

